export const serviceContactCategoryTitleTokens = {
  colors: {
    background: "#e60012",
    contrastText: "#ffffff",
    standardText: "#000000",
    contrastDivider: "rgba(255, 255, 255, 0.28)",
    standardDivider: "rgba(0, 0, 0, 0.18)",
    contrastPattern: "rgba(255, 255, 255, 0.34)",
    standardPattern: "rgba(0, 0, 0, 0.2)",
    contrastPatternAccent: "rgba(0, 0, 0, 0.16)",
    standardPatternAccent: "rgba(0, 0, 0, 0.08)",
  },
  sizes: {
    maxWidth: 1180,
    icon: 34,
    mobileIcon: 30,
  },
  spacing: {
    shellY: 74,
    shellX: 24,
    tabletShellY: 62,
    mobileShellY: 48,
    mobileShellX: 18,
    headerGap: 34,
    contactGap: 24,
  },
  radius: {
    focus: 8,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    title: {
      fontSize: 48,
      tabletFontSize: 44,
      mobileFontSize: 30,
      lineHeight: 1.08,
      fontWeight: 850,
      letterSpacing: 0,
    },
    cta: {
      fontFamily: 'Georgia, "Times New Roman", serif',
      fontSize: 32,
      tabletFontSize: 28,
      mobileFontSize: 21,
      lineHeight: 1.24,
      fontWeight: 700,
      letterSpacing: 0,
      fontStyle: "italic" as const,
    },
    contact: {
      fontSize: 18,
      mobileFontSize: 14,
      lineHeight: 1.18,
      fontWeight: 800,
      letterSpacing: 0,
    },
  },
  patterns: {
    angled: {
      dotSize: 9,
      dotOpacity: 0.24,
      bandOpacity: 0.48,
    },
    dots: {
      dotSize: 8,
      dotOpacity: 0.2,
      bandOpacity: 0,
    },
    bands: {
      dotSize: 10,
      dotOpacity: 0,
      bandOpacity: 0.4,
    },
  },
  defaults: {
    pattern: "angled",
    title: "General Pest Control",
    ctaMessage:
      "Call, message or WhatsApp us today for general pest control in Sydney.",
    contacts: [
      {
        label: "Email us",
        href: "mailto:info@example.com",
        icon: "email",
        method: "email",
      },
      {
        label: "Call us today",
        href: "tel:0425336966",
        icon: "phone",
        method: "phone",
      },
      {
        label: "Send a message",
        href: "sms:0425336966",
        icon: "message",
        method: "sms",
      },
      {
        label: "Chat on WhatsApp",
        href: "https://wa.me/61425336966",
        icon: "whatsapp",
        method: "whatsapp",
        target: "_blank",
        rel: "noopener noreferrer",
      },
    ],
    emailSubjectTemplate: "{serviceName} enquiry",
    responseTemplate:
      "Hi, I would like to enquire about {serviceName}.",
    fallbackResponseTemplate: "Hi, I would like to make an enquiry.",
  },
} as const;

export type ServiceContactCategoryTitlePatternToken =
  keyof typeof serviceContactCategoryTitleTokens.patterns;

export type ServiceContactCategoryTitleIconToken =
  (typeof serviceContactCategoryTitleTokens.defaults.contacts)[number]["icon"];
